module.exports = __webpack_public_path__ + "img/skorochtenie.2a89c0c4.jpg";